import React, { useState } from 'react';
import Grid from '@mui/joy/Grid';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';

export default function StepGearbox({ getDataFromStepMotor, getDataFromStepGearbox, gearBoxValue, motorValue }) {

    const handleInputChangeMotor = (e) => {
        // getDataFromStepFour(e.target.value)
        getDataFromStepMotor(e.target.value)
    };

    const handleInputChangeGearbox = (e) => {
        getDataFromStepGearbox(e.target.value)
    }

    return (
        <Grid
            container
            direction='row'
            spacing={4}
        >
            <Grid xs={12}>
                <Typography level="h3" sx={{ fontSize: '16px', color: '#434448', fontWeight: 'bold' }}>مبلغ الخصم من حالة المحرك</Typography>
            </Grid>
            <Grid xs={12}>
                <FormControl sx={{ width: '20%' }}>
                    <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>تم تغيير المحرك او توظيبه بالكامل</FormLabel>
                    <Input
                        placeholder="00.00"
                        type='number'
                        sx={{ borderRadius: '30px', height: '60px' }}
                        value={motorValue}
                        onChange={handleInputChangeMotor}
                    />
                </FormControl>
            </Grid>

            <Grid xs={12}>
                <Typography level="h3" sx={{ fontSize: '16px', color: '#434448', fontWeight: 'bold' }}>مبلغ الخصم من حالة الجيربوكس</Typography>
            </Grid>
            <Grid xs={12}>
                <FormControl sx={{ width: '20%' }}>
                    <FormLabel sx={{ fontSize: '16px', color: '#434448', marginBottom: '10px' }}>تم تغييره</FormLabel>
                    <Input
                        placeholder="00.00"
                        type='number'
                        sx={{ borderRadius: '30px', height: '60px' }}
                        value={gearBoxValue}
                        onChange={handleInputChangeGearbox}
                    />
                </FormControl>
            </Grid>

        </Grid>
    );
}